/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {
	const scrollToTops = document.querySelectorAll('.wp-block-wpe-thom-go-to-top-block');

	// Return early, and often.
	if (!scrollToTops.length) {
		return;
	}

	var selector = '.wp-block-wpe-thom-go-to-top-block';

	window.addEventListener('scroll', function () {
		if (window.scrollY > 400) {
			document.querySelector(selector).style.opacity = '1';
		} else {
			document.querySelector(selector).style.opacity = '0';
		}
	});

	document.querySelector(selector).addEventListener('click', function (e) {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

});
/* eslint-enable no-console */
